import { useState, useEffect } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FormContainer from "../components/FormContainer";
import CheckoutSteps from "../components/CheckoutSteps";
import { savePaymentMethod } from "../slices/cartSlice";

const PaymentScreen = () => {
  const navigate = useNavigate();
  const cart = useSelector((state) => state.cart);
  const { shippingAddress } = cart;

  useEffect(() => {
    if (!shippingAddress.address) {
      navigate("/shipping");
    }
  }, [navigate, shippingAddress]);

  const [paymentMethod, setPaymentMethod] = useState("PayPal");

  const dispatch = useDispatch();

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(savePaymentMethod(paymentMethod));
    navigate("/placeorder");
  };

  return (
    <FormContainer>
      <CheckoutSteps step1 step2 step3 />
      <h1 className="text-end">שיטת תשלום</h1>
      <Form onSubmit={submitHandler}>
        <Form.Group>
          <Form.Label as="legend" className="text-end">
            בחר
          </Form.Label>
          <Col className="d-flex justify-content-end">
            <Form.Check
              className="my-2"
              type="radio"
              label="פייפאל או כרטיס אשראי"
              id="PayPal"
              name="paymentMethod"
              value="PayPal"
              checked
              onChange={(e) => setPaymentMethod(e.target.value)}
            ></Form.Check>
          </Col>
        </Form.Group>

        <Row className="my-2">
          <Col className="d-flex justify-content-end">
            <Button type="submit" variant="primary">
              המשך
            </Button>
          </Col>
        </Row>
      </Form>
    </FormContainer>
  );
};

export default PaymentScreen;
